"use client";

import { useEffect } from "react";

// ============================================
// Toast — bottom-center notification
// ============================================

interface ToastProps {
  message: string | null;
  onClear: () => void;
}

export default function Toast({ message, onClear }: ToastProps) {
  useEffect(() => {
    if (!message) return;
    const timer = setTimeout(() => {
      onClear();
    }, 2200);
    return () => clearTimeout(timer);
  }, [message, onClear]);

  return (
    <div className={`toast${message ? " show" : ""}`}>
      {message ?? ""}
    </div>
  );
}
